import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import Make from "./Make";
import Model from "./Model";
import MakeAndModel from "./MakeAndModel";

const FuelAllocationSetupKMBased = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [returnsProduct, setReturnsProduct] = useState("");
  const [returnsProductCode, setReturnsProductCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [returnsQty, setReturnsQty] = useState("");
  const [returnsPoNo, setReturnsPoNo] = useState("");

  const [adviceNo, setAdviceNo] = useState("");
  const [adviceDate, setAdviceDate] = useState(new Date().toISOString());
  const [routeFrom, setRouteFrom] = useState("");
  const [routeTo, setRouteTo] = useState("");
  const [routeId, setRouteId] = useState("");
  const [uom, setUom] = useState("");
  const [mill, setMill] = useState("");
  const [routeList, setRoutList] = useState([]);
  const [millsList, setMillsList] = useState([]);

  const [selMake, setSelMake] = useState("");
  const [makeList, setMakeList] = useState([]);
  const [selModel, setSelModel] = useState("");
  const [modelList, setModelList] = useState([]);
  const [kmLtr, setKmLtr] = useState("");
  const [routesList, setRoutesList] = useState([]);
  const [routeNo, setRouteNo] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [selTrialerType, setSelTrailerType] = useState("");
  const [trialerTypeList, setTrailerTypeList] = useState([]);
  const [selTrailerCategory, setSelTrailerCategory] = useState("");
  const [trailerCategoryList, setTrailerCategoryList] = useState([]);
  const [selFromStation, setSelFromStation] = useState("");
  const [selFromStationCode, setSelFromStationCode] = useState("");
  const [fromStationList, setFromStationList] = useState([]);
  const [selOrderBy, setSelOrderBy] = useState("");
  const [selOrderByLabel, setSelOrderByLabel] = useState("");
  const [orderByList, setOrderByList] = useState([]);
  const [singleDiff, setSingleDiff] = useState(false);
  const [doubleDiff, setDoubleDiff] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [trailerDependant, setTrailerDepandant] = useState([]);
  const [loactionLevel, setLocationLevel] = useState(false);
  const [showRoutes, setShowRoutes] = useState(false);
    const [showMakes, setShowMakes] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showMakeAndModel, setShowMakeAndModel] = useState(false);
const [topUpLitres,setTopUpLitres] = useState("");

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = tableData
    .filter((item) => {
      const searchData = search.toLowerCase().split(" ").filter(Boolean);

      if (searchData.length === 0) {
        return true;
      }

      const textMatch = searchData.every((term) => {
        return [
          "OM_FUEL_TRACTOR_MAKE",
          "OM_FUEL_ROUTE_ID",
          "OM_FUEL_TRAILER_CATEGORY",
          "OM_FUEL_TRAILER_TYPE",
          "OT_FUEL_TO_LOAD_FROM_LOCATION",
          "OM_FUEL_SINGLE_DOUBLE_DIFF",
          "OM_FUEL_KM_PER_LITRE",
        ].some((key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        });
      });

      return textMatch;
    })
    .sort((a, b) => {
      if (!selOrderBy) return 0; // No sorting if none selected

      const valA = String(a[selOrderBy] || "").toLowerCase();
      const valB = String(b[selOrderBy] || "").toLowerCase();

      if (valA < valB) return -1;
      if (valA > valB) return 1;
      return 0;
    });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    // 358 - From Station List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=358`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setFromStationList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching From Station Lsit:", error);
      });

    // 653 - Routes List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=653`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRoutesList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Routes Lsit:", error);
      });

    // 1109 - VEHICLE MAKE IN DROPDOWN
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1109`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setMakeList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Make Lsit:", error);
      });

    // 1110
    // TRAILER TYPES
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1110`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTrailerTypeList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Trailer Types List:", error);
      });

    // 1111 - Vehicle category
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1111`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTrailerCategoryList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Trailer Category List:", error);
      });

    // 1112 - VIEW FUEL SETUP IN GRID
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1112`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTableData(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Table details Details:", error);
      });
  };

  function getModelsBasedOnMake(make) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=934&OM_VEHICLE_MAKE=${make}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      )
      .then((response) => {
        setModelList(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });
  }

  // Saving
  async function Save() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1113`,
        {
          SINGLEDOUBLE:
            singleDiff === true
              ? "SINGLE"
              : doubleDiff === true
              ? "DOUBLE"
              : "",
          MAKE: selMake ? selMake : "",
          MODEL: selModel ? selModel : "",
          ROUTEID: routeNo ? routeNo : 0,
          TRAILERTYPE: selTrialerType ? selTrialerType : "",
          VEHICLECATEGORY: selTrailerCategory ? selTrailerCategory : "",
          LITERPERKM: kmLtr ? Number(kmLtr) : 0,
          TRAILERDEPENDANT: trailerDependant === true ? 1 : 0,
          CREATEDBY: user,
          LOCATION: selFromStationCode ? selFromStationCode : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Fuel Allocation Saved successfully`);
        console.log(`Fuel Allocation Saved successfully`);
        window.location.reload();
      } else {
        setisloading(false);
        console.error(`Error while saving Fuel Allocation`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Fuel Allocation`, error);
    }
  }

  const handleRowClick = (value, index) => {
    setVehicleNo(value["VEHICLE REG NO"]);
    // fetchLastGateInNo(value?.OT_VEHICLE_REG_NO);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Fuel Allocation Setup KM Based
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      {/* Line 1 */}
      <div className="lg:flex lg:flex-row mt-2">
        <p className="lg:ml-2 ">Vehicle Make :</p>
        <Select
          className="lg:w-64 w-64 lg:ml-2"
          value={
            selMake
              ? { value: selMake, label: selMake }
              : { value: "", label: "Select Make" }
          }
          onChange={(e) => {
            if (e.value !== "") {
              setSelMake(e.value);
              getModelsBasedOnMake(e.value);
            } else {
              setSelMake("");
            }
          }}
          options={[
            { value: "", label: "Select Make" },
            ...makeList?.map((item) => ({
              value: item.MAKE,
              label: item.MAKE,
            })),
          ]}
        ></Select>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => setShowMakes(true)}
        >
          New Make
        </button>

         {showMakes && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[550px] h-[80%] lg:w-[1250px] w-[95%] p-1 overflow-y-auto z-[500]">
            <Make hideNavbar={true} />

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowMakes(false)}
            >
              Close
            </button>
          </div>
        )}

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            setSelMake("");
            setSelModel("");
          }}
        >
          Refresh
        </button>

        <p className="lg:ml-16 ">Vehicle Model :</p>
        <Select
          className="lg:w-64 w-64 lg:ml-2"
          value={
            selModel
              ? { value: selModel, label: selModel }
              : { value: "", label: "Select Model" }
          }
          onChange={(e) => {
            if (!selMake) {
              alert("Kindly Supply Make first");
            } else {
              setSelModel(e.value);
            }
          }}
          options={[
            { value: "", label: "Select Model" },
            ...modelList?.map((item) => ({
              value: item.OM_VEHICLE_MODEL,
              label: item.OM_VEHICLE_MODEL,
            })),
          ]}
        ></Select>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-4 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => setShowModel(true)}
        >
          New Model
        </button>

        
        
         {showModel && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[550px] h-[80%] lg:w-[1250px] w-[95%] p-1 overflow-y-auto z-[500]">
            <Model hideNavbar={true} />

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowModel(false)}
            >
              Close
            </button>
          </div>
        )}


        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-3 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => setShowMakeAndModel(true)}
        >
          Make and Model
        </button>


          {showMakeAndModel && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[550px] h-[80%] lg:w-[1250px] w-[95%] p-1 overflow-y-auto z-[500]">
            <MakeAndModel hideNavbar={true} />

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowMakeAndModel(false)}
            >
              Close
            </button>
          </div>
        )}


      </div>

      {/* Line 2 */}
      <div className="lg:flex lg:justify-between mt-2">
        <div className="flex">
          <p className="lg:ml-2 ">KM/ltr :</p>
          <input
            className="w-20 text-right h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="number"
            value={kmLtr}
            onChange={(e) => setKmLtr(e.target.value)}
          ></input>
        </div>
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={async () => {
            await Save();
          }}
        >
          SAVE
        </button>
      </div>

      {/* Line 3  */}
      <div className="lg:flex lg:flex-row mt-2">
        <p className="lg:ml-2 lg:mr-1">Route :</p>
        <input
          className="w-20 text-right h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={routeNo}
          readOnly
        ></input>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            setShowRoutes(true);
          }}
        >
          ...
        </button>

        {/* Routes PopUp */}
        {showRoutes && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
            <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="sticky top-0">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      ROUTE ID
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      FROM LOCATION
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      TO LOCATION
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {routesList.map((value, index) => (
                    <tr
                      key={value?.ROUTEID}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setRouteNo(value.ROUTEID);
                        setFromLocation(value.STARTLOC);
                        setToLocation(value.ENDLOC);
                      }}
                    >
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.ROUTEID || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.STARTLOC || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.ENDLOC || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowRoutes(false)}
            >
              Close
            </button>
          </div>
        )}

        <p className="lg:ml-20">From :</p>
        <input
          className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={fromLocation}
          readOnly
        ></input>
        <p className="lg:ml-16">To :</p>
        <input
          className="w-64 h-8 border border-black lg:ml-2 lg:mr-4 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={toLocation}
          readOnly
        ></input>

        <p className="lg:ml-1">Topup Litres :</p>
        <input
          className="w-28 h-8 border border-black lg:ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={topUpLitres}
          onChange={(e) => {
    const value = e.target.value;
    // Allow only digits
    if (/^\d*$/.test(value)) {
      setTopUpLitres(value);
    }
  }}
  onKeyDown={(e) => {
    // Block "e", "E", "+", "-", ".", etc.
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  }}
        ></input>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {}}
        >
          DELETE
        </button>
      </div>

      {/* Line 4 */}
      <div className="lg:flex lg:flex-row mt-2">
        <p className="lg:ml-2 ">Trailer Type :</p>
        <Select
          className="lg:w-96 w-64 lg:ml-5 lg:mr-3"
          value={
            selTrialerType
              ? { value: selTrialerType, label: selTrialerType }
              : { value: "", label: "Select Trialer Type" }
          }
          onChange={(e) => {
            setSelTrailerType(e.value);
          }}
          options={[
            { value: "", label: "Select Trailer Type" },
            ...trialerTypeList?.map((item) => ({
              value: item.OM_TRAILER_TYPE_NAME,
              label: item.OM_TRAILER_TYPE_NAME,
            })),
          ]}
        ></Select>

        <p className="lg:ml-24">Trailer Category :</p>
        <Select
          className="lg:w-72 w-64 lg:ml-2"
          value={
            selTrailerCategory
              ? { value: selTrailerCategory, label: selTrailerCategory }
              : { value: "", label: "Select Trailer Category" }
          }
          onChange={(e) => {
            setSelTrailerCategory(e.value);
          }}
          options={[
            { value: "", label: "Select Trailer Category" },
            ...trailerCategoryList?.map((item) => ({
              value: item.OM_VEHICLE_CATEGORY_NAME,
              label: item.OM_VEHICLE_CATEGORY_NAME,
            })),
          ]}
        ></Select>

        <input
          className="w-6 h-6 border border-black lg:ml-10  rounded-md focus:outline-none focus:border-blue-500"
          type="checkbox"
          checked={trailerDependant}
          onChange={(e) => setTrailerDepandant(!trailerDependant)}
        ></input>
        <p className="text-red-600 lg:ml-4">Trailer Dependent</p>
      </div>

      {/* Line 5 */}
      <div className="lg:flex lg:flex-row mt-2">
        <p className="lg:ml-2 ">From Station :</p>
        <Select
          className="lg:w-96 w-64 lg:ml-2"
          value={
            selFromStation
              ? { value: selFromStation, label: selFromStation }
              : { value: "", label: "Select From Station" }
          }
          onChange={(e) => {
            setSelFromStation(e.label);
            setSelFromStationCode(e.value);
          }}
          options={[
            { value: "", label: "Select From Station" },
            ...fromStationList?.map((item) => ({
              value: item.FUELLOCATIONCODE,
              label: item.FUELLOCATIONNAME,
            })),
          ]}
        ></Select>
        <input
          className="w-6 h-6 border border-black lg:ml-4  rounded-md focus:outline-none focus:border-blue-500"
          type="checkbox"
          checked={loactionLevel}
          onChange={() => setLocationLevel(!loactionLevel)}
        ></input>
        <p className="text-red-600 lg:ml-2">Location Level</p>

        <p className="lg:ml-2">Order By :</p>
        <Select
          className="lg:w-96 w-64 lg:ml-2"
          value={
            selOrderByLabel
              ? { value: selOrderByLabel, label: selOrderByLabel }
              : { value: "", label: "Select Order By" }
          }
          onChange={(e) => {
            setSelOrderBy(e.value);
            setSelOrderByLabel(e.label);
          }}
          options={[
            { value: "", label: "Select Order By" },
            { value: "OM_FUEL_ROUTE_ID", label: "Route ID" },
            { value: "OM_FUEL_TRACTOR_MAKE", label: "Make" },
          ]}
        ></Select>
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            setSelOrderBy("");
          }}
        >
          Refresh List
        </button>
      </div>

      {/* Line 6 */}
      <div className="lg:flex lg:justify-end mt-2">
        <div className="border border-gray-400 p-4 w-fit rounded-md relative mt-4">
          <p className="absolute -top-3 left-2 bg-white px-1 text-red-600 text-sm">
            Single or Double Diff
          </p>

          <div className="flex items-center space-x-6 mt-2">
            <label className="flex items-center space-x-2">
              <input
                type="radio"
                className="w-4 h-4"
                checked={singleDiff}
                onChange={() => {
                  setSingleDiff(true);
                  setDoubleDiff(false);
                }}
              />
              <span className="text-sm">Single Diff</span>
            </label>

            <label className="flex items-center space-x-2">
              <input
                type="radio"
                className="w-4 h-4"
                checked={doubleDiff}
                onChange={() => {
                  setSingleDiff(false);
                  setDoubleDiff(true);
                }}
              />
              <span className="text-sm">Double Diff</span>
            </label>
          </div>
        </div>

        <div className="flex flex-col gap-4 mt-4">
          <button
            className="lg:flex items-center h-8 justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {}}
          >
            Save Bulk
          </button>

          <button
            className="lg:flex items-center h-8 justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {}}
          >
            Delete Bulk
          </button>
        </div>
      </div>

      {/* Table */}

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ROUTE ID
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                FROM LOCATION
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TO LOCATION
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER DEPENDANT
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER CATEOGRY
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER TYPE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                LOAD FROM LOCATION
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                SINGLE / DOUBLE DIFF
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                KM PER LITRE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => {
              const route = routesList.find(
                (item) => item.ROUTEID == value.OM_FUEL_ROUTE_ID
              );
              const from = route?.STARTLOC;
              const to = route?.ENDLOC;
              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => handleRowClick(value, index)}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OM_FUEL_TRACTOR_MAKE || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {value.OM_FUEL_ROUTE_ID || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {from || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {to || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OM_FUEL_TRAILER_DEPENDANT === true ? "YES" : "NO"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OM_FUEL_TRAILER_CATEGORY || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OM_FUEL_TRAILER_TYPE || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OT_FUEL_TO_LOAD_FROM_LOCATION || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.OM_FUEL_SINGLE_DOUBLE_DIFF || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {value.OM_FUEL_KM_PER_LITRE || "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FuelAllocationSetupKMBased;
